module.exports = __webpack_public_path__ + "static/media/Maf_HomeOffice.8ca1d90c.jpg";